import(/* webpackMode: "eager" */ "/vercel/path0/apps/www/app/press/[...slug]/layout.tsx")